import { motion } from "framer-motion";
import { Home, Building2, MapIcon, Store, TrendingUp, ArrowLeftRight } from "lucide-react";

const categories = [
  { icon: Home, label: "Casas", description: "Residências e sobrados" },
  { icon: Building2, label: "Apartamentos", description: "Studios a coberturas" },
  { icon: MapIcon, label: "Terrenos", description: "Lotes urbanos e rurais" },
  { icon: Store, label: "Comerciais", description: "Salas, lojas e galpões" },
];

const benefits = [
  {
    icon: ArrowLeftRight,
    title: "Permuta direta",
    description: "Troque seu imóvel por outro sem intermediários. Você negocia direto com o proprietário.",
  },
  {
    icon: TrendingUp,
    title: "Zero comissão",
    description: "Sem taxas de corretagem. Economize até 6% do valor do imóvel na transação.",
  },
];

const CategoriesSection = () => {
  return (
    <section id="categorias" className="py-20 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-3">
            Que tipo de imóvel você quer permutar?
          </h2>
          <p className="text-muted-foreground font-body text-lg max-w-md mx-auto">
            Encontre proprietários interessados em trocar
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {categories.map((cat, i) => (
            <motion.button
              key={cat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              whileHover={{ y: -6, scale: 1.02 }}
              className="group relative overflow-hidden rounded-2xl bg-card p-6 shadow-card hover:shadow-card-hover transition-all duration-300 border border-border/50 text-left"
            >
              <div className="absolute top-0 right-0 w-24 h-24 bg-accent/5 rounded-full -translate-y-8 translate-x-8 group-hover:bg-accent/10 transition-colors" />
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-accent/20 transition-colors">
                <cat.icon className="text-primary group-hover:text-accent transition-colors" size={28} />
              </div>
              <h3 className="font-display font-bold text-foreground text-lg mb-1">{cat.label}</h3>
              <p className="text-sm text-muted-foreground font-body">{cat.description}</p>
            </motion.button>
          ))}
        </div>

        {/* Benefits */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {benefits.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="flex gap-5 p-6 rounded-2xl bg-primary/5 border border-primary/10"
            >
              <div className="w-12 h-12 rounded-xl bg-accent/15 flex items-center justify-center shrink-0">
                <b.icon className="text-accent" size={24} />
              </div>
              <div>
                <h3 className="font-display font-bold text-foreground mb-1">{b.title}</h3>
                <p className="text-sm text-muted-foreground font-body leading-relaxed">{b.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
